export default __webpack_public_path__ + "static/TradeGothicLTStd-Bd2-519cf83d5a2d14684675caa66e754c08.woff";